/* VAEN — Home interactions (dependency-free, re-runnable per section) */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function once(el, key) { if (el.dataset[key]) return false; el.dataset[key] = '1'; return true; }

  function init(scope) {
    scope = scope || document;
    var roots = scope.matches && scope.matches('.vn') ? [scope] : scope.querySelectorAll('.vn');
    Array.prototype.forEach.call(roots, function (root) {
      requestAnimationFrame(function () { root.classList.add('is-ready'); });
    });

    /* scroll reveals */
    var items = scope.querySelectorAll('.vn-reveal, .vn-closer__word');
    if ('IntersectionObserver' in window && !reduce) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      Array.prototype.forEach.call(items, function (el) { if (once(el, 'vnReveal')) io.observe(el); });
    } else {
      Array.prototype.forEach.call(items, function (el) { el.classList.add('is-in'); });
    }

    /* hero media: gentle scale on scroll */
    Array.prototype.forEach.call(scope.querySelectorAll('.vn-hero__media img'), function (heroImg) {
      if (reduce || !once(heroImg, 'vnHero')) return;
      var tick = false;
      window.addEventListener('scroll', function () {
        if (tick) return; tick = true;
        requestAnimationFrame(function () {
          var y = Math.min(window.scrollY, 900) / 900;
          heroImg.style.transform = 'scale(' + (1 + y * 0.06) + ')';
          tick = false;
        });
      }, { passive: true });
    });

    /* materials: active item + progress bar + image swap */
    Array.prototype.forEach.call(scope.querySelectorAll('.vn-mat'), function (sec) {
      if (!once(sec, 'vnMat')) return;
      var matItems = sec.querySelectorAll('.vn-mat__item');
      var bar = sec.querySelector('.vn-mat__bar i');
      var sticky = sec.querySelector('.vn-mat__sticky');
      if (!matItems.length) return;
      var setActive = function (i) {
        Array.prototype.forEach.call(matItems, function (el, k) { el.classList.toggle('is-active', k === i); });
        if (bar) bar.style.width = ((i + 1) / matItems.length * 100) + '%';
        if (sticky) {
          var src = matItems[i].getAttribute('data-image');
          var img = sticky.querySelector('img');
          if (src && img && img.getAttribute('src') !== src) { img.removeAttribute('srcset'); img.src = src; }
          var lab = sticky.querySelector('[data-mat-label]');
          if (lab) lab.textContent = matItems[i].getAttribute('data-label') || '';
        }
      };
      setActive(0);
      if (!('IntersectionObserver' in window)) return;
      var mio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) setActive(Array.prototype.indexOf.call(matItems, e.target));
        });
      }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
      Array.prototype.forEach.call(matItems, function (el) { mio.observe(el); });
    });

    /* finish configurator */
    Array.prototype.forEach.call(scope.querySelectorAll('.vn-fin'), function (sec) {
      if (!once(sec, 'vnFin')) return;
      var sws = sec.querySelectorAll('.vn-sw');
      var stageImgs = sec.querySelectorAll('.vn-fin__stage img');
      var finName = sec.querySelector('[data-fin-name]');
      var finCode = sec.querySelector('[data-fin-code]');
      Array.prototype.forEach.call(sws, function (btn) {
        btn.addEventListener('click', function () {
          var key = btn.getAttribute('data-finish');
          Array.prototype.forEach.call(sws, function (b) { b.classList.toggle('is-on', b === btn); });
          Array.prototype.forEach.call(stageImgs, function (im) { im.classList.toggle('is-on', im.getAttribute('data-finish') === key); });
          if (finName) finName.textContent = btn.getAttribute('data-name') || key;
          if (finCode) finCode.textContent = btn.getAttribute('data-code') || '';
        });
      });
    });

    /* videos: make sure they actually play */
    Array.prototype.forEach.call(scope.querySelectorAll('.vn video'), function (v) {
      v.muted = true; v.playsInline = true; v.setAttribute('playsinline', '');
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    });

    /* FAQ: one open at a time */
    Array.prototype.forEach.call(scope.querySelectorAll('.vn-acc'), function (acc) {
      if (!once(acc, 'vnAcc')) return;
      var dets = acc.querySelectorAll('details');
      Array.prototype.forEach.call(dets, function (d) {
        d.addEventListener('toggle', function () {
          if (d.open) Array.prototype.forEach.call(dets, function (o) { if (o !== d) o.open = false; });
        });
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  /* Shopify Theme Editor: re-init when a section is (re)rendered */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.VAENHome = { init: init };
})();
